import React, {ChangeEvent} from 'react';

import {Choice, Field, FieldProp} from '../../types';
import {FormState} from '../Form';

type CheckboxProps = FieldProp & {};

export const Checkbox: React.FunctionComponent<CheckboxProps> = ({
                                                                     form,
                                                                     field,
                                                                     formState,
                                                                     fieldState,
                                                                     value = [],
                                                                     displayOnly,
                                                                     onChange,
                                                                     onBlur,
                                                                 }): JSX.Element => {
    const {touched, pristine, valid, invalid, errors} = fieldState;

    const classNames = [
        'form-check-input',
        touched && 'is-touched',
        pristine && 'is-pristine',
        valid && 'is-valid',
        invalid && 'is-invalid',
    ]
        .filter(Boolean)
        .join(' ');

    const collectionFieldIds = field?.flowCustomDisplayComponentConfig?.collection?.fields || [];
    const collectionFieldIdsFiltered = collectionFieldIds.filter(fid => fid !== field.id);

    // @ts-ignore
    const advancedFilter = (formState: FormState | undefined, field: Field) => {
        if (field?.flowCustomDisplayComponentConfig?.filterFunction) {
            // @ts-ignore - item used within filterFunction
            return (item: Choice) => {
                let result = false;
                try {
                    // tslint:disable-next-line:no-eval
                    result = eval(field.flowCustomDisplayComponentConfig.filterFunction);
                } catch (e) {
                    console.log('Exception', e);
                    result = false;
                }
                return result;
            };
        } else {
            return () => true;
        }
    };

    const fieldChoices = field.choices.filter(advancedFilter(formState, field));

    return (
        <div>
            {fieldChoices && fieldChoices.map((choice: Choice, index: number) => {
                const isChecked = (value && value?.find((item: Choice) => item.value === choice.value) !== undefined);
                if (displayOnly && !isChecked) return;

                return (
                    <div key={`${field.id}-${index}`}
                         className="form-check">
                        {displayOnly ?
                            isChecked && <div>{choice.text}</div>
                            :
                            <div>
                                <input
                                    id={`${field.id}-${index}`}
                                    className={classNames}
                                    type="checkbox"
                                    value={choice.value}
                                    checked={isChecked}
                                    onBlur={() => {
                                        onBlur && onBlur()
                                    }}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                        if (e.target.checked) {
                                            // clear out any other fields in collection
                                            const collectionState = collectionFieldIdsFiltered.reduce((acc: any, fieldId: any) => {
                                                const collectionField = form?.fieldMap.hasOwnProperty(fieldId) ? form.fieldMap[fieldId] : null;
                                                if (collectionField) {
                                                    return {
                                                        ...acc,
                                                        [collectionField.name]: []
                                                    }
                                                } else {
                                                    return acc;
                                                }
                                            }, {});

                                            onChange([...value, choice], collectionState);
                                        } else {
                                            onChange(value.filter((item: Choice) => item.value !== choice.value));
                                        }
                                    }}
                                />
                                <label className="form-check-label" htmlFor={`${field.id}-${index}`}>
                                    {choice.text}
                                </label>
                            </div>
                        }
                    </div>
                )
            })}

            {errors && errors.map((error: string, index: number) => (
                <div key={index} className="invalid-feedback">
                    {error}
                </div>
            ))}
        </div>
    );
};
